export const CustomTag = {
	tagOutlineTextColor: 'var(--epods--color-text-tag-outline)',
	tagOutlineTextDisabledColor: 'var(--epods--color-text-tag-outline-disabled)',
};
